import FUELS_KEYS, {FuelCode} from './FuelsKeys'
import Option from './Option'

export default function getOptions(
    optionsArr?: string[],
    translateOptions: boolean = false
): Option {
    const options: Option = {}
    const uniqueOptions = [...new Set(optionsArr)]

    for (const opt of uniqueOptions) {
        // eslint-disable-next-line security/detect-object-injection
        options[opt] = translateOptions ? FUELS_KEYS[opt as FuelCode] : opt
    }

    return options
}
